/* eslint-disable @typescript-eslint/naming-convention */
export const babylonDemoEffectsNamespace = "Babylon.Demo.Effects";
export const babylonDemoUtilitiesNamespace = "Babylon.Demo.Utilities";
export const babylonDemoTransitionsNamespace = "Babylon.Demo.Transitions";
export const inputsNamespace = "Inputs";
/* eslint-enable @typescript-eslint/naming-convention */
//# sourceMappingURL=blockNamespaces.js.map